import React, { useState, useEffect, useRef } from 'react';
import api from '../../api/axiosConfig';
import './TwoFactorModal.css';

const TwoFactorModal = ({ pendingToken, onSuccess, onError }) => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [rememberDevice, setRememberDevice] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await api.post('/verificarLogin2FA', {
        pendingToken,
        twoFactorCode: code,
        rememberDevice
      });
      onSuccess(response.data);
    } catch (err) {
      const msg = err.response?.data?.error || 'Código inválido. Intentá de nuevo.';
      setError(msg);
      if (onError) onError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="twofactor-overlay">
      <div className="twofactor-modal">
        <h3>Verificación de dos pasos</h3>
        <p>Ingresá el código de 6 dígitos de tu aplicación de autenticación</p>

        {error && <div className="twofactor-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <input
            ref={inputRef}
            type="text"
            className="twofactor-input"
            value={code}
            onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
            placeholder="000000"
            maxLength={6}
            autoComplete="one-time-code"
            disabled={loading}
          />

          <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', marginBottom: '16px', fontSize: '13px', color: '#4a5568', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={rememberDevice}
              onChange={e => setRememberDevice(e.target.checked)}
              disabled={loading}
              style={{ accentColor: '#2a5a8a' }}
            />
            Recordar este dispositivo por 30 días
          </label>

          <button
            type="submit"
            className="twofactor-submit-btn"
            disabled={loading || code.length !== 6}
          >
            {loading ? 'Verificando...' : 'Verificar'}
          </button>
        </form>

      </div>
    </div>
  );
};

export default TwoFactorModal;
